@if (source()) {
  <ng-container *transloco="let t">
    @switch (state()) {
      @case (ActionStatus.IN_PROGRESS) {
        <pxc-image-loading class="absolute inset-0" />
      }
      @case (ActionStatus.ERROR) {
        <pxc-error-icon
          class="absolute inset-0 flex items-center justify-center"
          data-testid="picture-aruco-error"
          [message]="t('Impossible de charger l\'image.')" />
      }
    }
    <img
      arucoDetector
      class="size-full object-cover"
      crossorigin="anonymous"
      pxcImageLoad
      [hidden]="state() !== ActionStatus.SUCCESS"
      [showDetectedSticker]="true"
      [src]="source()"
      (arucoSticker)="emitArucoSticker($event)"
      (loadError)="onPictureError()"
      (loadSuccess)="onPictureLoad()" />
  </ng-container>
}
